import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import QuizRoundedIcon from '@mui/icons-material/QuizRounded';
import LayersRoundedIcon from '@mui/icons-material/LayersRounded';
import MonitorRoundedIcon from '@mui/icons-material/MonitorRounded';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import { getLngsltd } from '../../utils/langData.utils';

export const SideBarItemsForStudent = () => {
  const lngsltd = getLngsltd();
  if (!lngsltd) return []

  // SideBar items using lngsltd values from state
  const sideBarItems = [
    {
      path: "/home",
      label: lngsltd?.['Home'] || 'Home',
      icon: <DashboardRoundedIcon />,
      tooltip: lngsltd?.['Home'] || 'Home',
      backgroundColor: "blue",
    },
    {
      path: "/about",
      label: lngsltd?.['About'] || 'About',
      icon: <InfoRoundedIcon />,
      tooltip: lngsltd?.['About'] || 'About',
    },
    {
      path: "/courses",
      label: lngsltd?.['Courses'] || 'Courses',
      icon: <MonitorRoundedIcon />,
      tooltip: lngsltd?.['Courses'] || 'Courses',
    },
  ];

  return sideBarItems; // Return the sidebar items for use in other components
};


export const SideBarItemsForAdmin = () => {
  const lngsltd = getLngsltd();
  if (!lngsltd) return []

  const sideBarItems = [
    {
      path: "/home",
      label: lngsltd?.['Home'] || 'Home',
      icon: <DashboardRoundedIcon />,
      tooltip: lngsltd?.['Home'] || 'Home',
      backgroundColor: "blue",
    },
    {
      path: "/dashboard",
      label: lngsltd?.['Dashboard'] || 'Dashboard',
      icon: <SpaceDashboardRoundedIcon />,
      tooltip: lngsltd?.['Dashboard'] || 'Dashboard',
      backgroundColor: "blue",
    },
    {
      path: "/about",
      label: lngsltd?.['About'] || 'About',
      icon: <InfoRoundedIcon />,
      tooltip: lngsltd?.['About'] || 'About',
      backgroundColor: "blue",
    },
    {
      path: "/groups",
      label: lngsltd?.['Groups'] || 'Groups',
      icon: <LayersRoundedIcon />,
      tooltip: lngsltd?.['Groups'] || 'Groups',
    },
    {
      path: "/users",
      label: lngsltd?.['Users'] || 'Users',
      icon: <PeopleAltRoundedIcon />,
      tooltip: lngsltd?.['Users'] || 'Users',
    },
    {
      path: "/quiz",
      label: lngsltd?.['Quiz'] || 'Quiz',
      icon: <QuizRoundedIcon />,
      tooltip: lngsltd?.['Quiz'] || 'Quiz',
    },
    {
      path: "/usergroup",
      label: lngsltd?.['UserGroup'] || 'UserGroup',
      icon: <Groups2RoundedIcon />,
      tooltip: lngsltd?.['UserGroup'] || 'UserGroup',
    },
    {
      path: "/courses",
      label: lngsltd?.['Courses'] || 'Courses',
      icon: <MonitorRoundedIcon />,
      tooltip: lngsltd?.['Courses'] || 'Courses',
    },
    {
      path: "/reports",
      label: lngsltd?.['Reports'] || 'Reports',
      icon: <ArticleRoundedIcon />,
      tooltip: lngsltd?.['Reports'] || 'Reports',
    },
  ];

  return sideBarItems; // Return the sidebar items for use in other components
};
